const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "NOTE_TEMPLATES_RETRIEVED":
            return action.templates;

        default:
            return state;
    }
}
